module.exports = __webpack_public_path__ + "img/android-icon-192x192.1f93d59c.png";